exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".address-search{margin:25px 0}.address-search .input-group{width:100%}.address-search .address-search-title{color:#545454;font-weight:700}.address-search .address-search-title.no-underline{border-bottom:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/AddressSearch/AddressSearch.scss
 ** module id = 1185
 ** module chunks = 0
 **/